import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { setRoleMap } from "@/lib/constants";

const AuthContext = createContext(null);

async function cargarRoles() {
  try {
    const rm = await api.get("/roles-map");
    setRoleMap(rm.data);
  } catch (e) {
    console.error("No se pudo cargar el mapa de roles:", e);
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = no auth, obj = auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me")
      .then(async (res) => {
        await cargarRoles();
        setUser(res.data);
      })
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    await cargarRoles();
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.error("Error al cerrar sesión:", e);
    }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
